import React from 'react';
import ReactDOM from 'react-dom';
import Engine from 'components/widgets/engines';
import 'react-dates/initialize';

const engineElement = document.getElementById('sch_engine');


if (engineElement !== null) {
    // const config = JSON.parse(engineElement.dataset.config);
    ReactDOM.render(<Engine module={engineElement.getAttribute('module')} token={engineElement.getAttribute('token')} redirectTo={engineElement.getAttribute('redirectTo')} commonDateFormat={engineElement.getAttribute('commonDateFormat')}/>, engineElement);
}
